export const COPY_CARD_EVENT_START = "COPY_CARD_EVENT_START";
export const COPY_CARD_EVENT_SUCCESS = "COPY_CARD_EVENT_SUCCESS";
export const COPY_CARD_EVENT_FAIL = "COPY_CARD_EVENT_FAIL";
export const COPY_CARD_EVENT_RESET = "COPY_CARD_EVENT_RESET";
